import LoginIntro from './LoginIntro';
import LoginForm from './LoginForm';

export default function LoginContent() {
  return (
    <div className='space-above'>
      <LoginIntro />
      <LoginForm />
    </div>
  );
}

